import { t } from "./labelHelpers";

const OVERLAY_ID = "pdf-loader-overlay";

const OVERLAY_CSS = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  flex-direction: column;
  gap: 1.5rem;
`;

function progressHtml(percentage: number, progressText: string): string {
  return `
    <div style="
      width: 500px;
      max-width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
    ">
      <h3 style="
        color: #333;
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
        text-align: center;
      ">${progressText}</h3>
      <div style="
        width: 100%;
        height: 24px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        overflow: hidden;
        position: relative;
      ">
        <div id="pdf-progress-bar" style="
          width: ${percentage}%;
          height: 100%;
          background: linear-gradient(90deg, #4a90d9, #6ba3e0, #4a90d9);
          background-size: 200% 100%;
          animation: shimmer 2s infinite;
          transition: width 0.3s ease;
          border-radius: 12px;
          position: relative;
        ">
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            animation: shine 1.5s infinite;
          "></div>
        </div>
      </div>
      <style>
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes shine {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      </style>
      <p style="
        color: #666;
        font-size: 0.875rem;
        text-align: center;
        margin: 0;
      ">${t("por_favor_espera_pdf")}</p>
    </div>
  `;
}

// Crea u actualiza el overlay de progreso de generación de PDF.
export function createOrUpdateLoader(current: number = 1, total: number = 1): void {
  let loaderOverlay = document.getElementById(OVERLAY_ID) as HTMLElement | null;
  if (!loaderOverlay) {
    loaderOverlay = document.createElement("div");
    loaderOverlay.id = OVERLAY_ID;
    loaderOverlay.style.cssText = OVERLAY_CSS;
    document.body.appendChild(loaderOverlay);
  }

  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
  const progressText = total > 1
    ? `${t("generando_pdf")} ${current} / ${total} (${percentage}%)`
    : `${t("generando_pdf")}...`;

  loaderOverlay.innerHTML = progressHtml(percentage, progressText);
}

export function removeLoader(): void {
  const loader = document.getElementById(OVERLAY_ID);
  if (loader) document.body.removeChild(loader);
}
